import React from 'react'
import {createRoot} from 'react-dom/client'
import '@ant-design/v5-patch-for-react-19'
import './sass/styles.sass'
import Root from './Root'
import App from './app/App'
import {ConfigProvider, theme} from 'antd'
import locale from "antd/es/locale/cs_CZ"
import {createAnalytics} from './app/utils'

// Run App for the first time
const $app = App.instance
const root = createRoot(document.getElementById('root'))

window.addEventListener('load', () => {

  createAnalytics('GTM-NVSR2TP4')

})

root.render(
  //<React.StrictMode>
  <ConfigProvider
    locale={locale}
    theme={{
      algorithm: theme.darkAlgorithm,
      token: {
        colorPrimary: '#397c88',
        borderRadius: 10,
        fontFamily: '\'Inter\', -apple-system, BlinkMacSystemFont, Roboto, Arial, sans-serif'
      }
    }}>
    <Root $app={$app}/>
  </ConfigProvider>
  //</React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals()
